<template>
    <div class='voice-wrapper'>
        <svg xmlns="http://www.w3.org/2000/svg"
             width="49"
             height="49"
             viewBox="0 0 49 49">
            <g id="组_260"
               data-name="组 260"
               transform="translate(-164 -263)">
                <g id="组_255"
                   data-name="组 255"
                   class="cls-1"
                   transform="translate(156 -363)">
                    <g id="组_250"
                       data-name="组 250"
                       transform="translate(22 633)">
                        <path id="路径_1294"
                              data-name="路径 1294"
                              class="cls-2"
                              d="M98.25,110.733c4.166,0,7.561-3.1,7.561-6.9v-6.2a.553.553,0,0,0,.042-.178.543.543,0,0,0-.042-.176V91.965c0-3.805-3.4-6.9-7.561-6.9s-7.561,3.1-7.561,6.9v11.865C90.689,107.635,94.082,110.733,98.25,110.733Zm-6.273-9.041h2.964a.591.591,0,1,0,0-1.177H91.978V98.025H95.05a.591.591,0,1,0,0-1.176H91.978V94.357h2.964a.591.591,0,1,0,0-1.176H91.978V91.965a6.3,6.3,0,0,1,12.544,0v1.216h-2.662a.591.591,0,1,0,0,1.176h2.662v2.491h-2.662a.591.591,0,1,0,0,1.176h2.662v2.491h-2.662a.591.591,0,1,0,0,1.177h2.662v2.137a6.3,6.3,0,0,1-12.544,0Z"
                              transform="translate(-87.987 -85.061)" />
                        <path id="路径_1295"
                              data-name="路径 1295"
                              class="cls-2"
                              d="M100.3,107.487c5.361-.376,9.6-5.143,9.6-10.944a.66.66,0,1,0-1.318,0c0,5.261-4.021,9.558-8.941,9.558S90.7,101.8,90.7,96.543a.661.661,0,1,0-1.32,0c0,5.8,4.242,10.568,9.6,10.944v4.462H95.951a.706.706,0,0,0,0,1.409h7.382a.706.706,0,0,0,0-1.409H100.3v-4.462Z"
                              transform="translate(-89.381 -79.157)" />
                    </g>
                </g>
                <g id="椭圆_17"
                   data-name="椭圆 17"
                   class="cls-3"
                   transform="translate(164 263)">
                    <circle class="cls-5"
                            cx="24.5"
                            cy="24.5"
                            r="23.75" />
                </g>
            </g>
        </svg>
        <div class="text">语音结束 转换文字</div>
    </div>
</template>

<script>
import anime from 'animejs'
export default {
    props: {
        el: {
            type: String,
            default: ''
        },
        maxDuration: {
            type: Number,
            default: 30000
        }
    },
    data() {
        return {
            record: null
        }
    },
    methods: {
        start(duration=this.maxDuration) {
            if (this.record) {
                this.record.restart()
            } else {
                this.record = anime.timeline({
                    easing: 'easeInOutSine',
                    complete: this.stop
                })
                this.record
                    .add({
                        targets: this.$el,
                        opacity: [0, 1],
                        duration: 350
                    })
                    .add({
                        targets: '#椭圆_17 circle',
                        strokeDashoffset: [anime.setDashoffset, 0],
                        duration: duration
                    })
            }
        },
        stop() {
            anime({
                targets: this.$el,
                opacity: 0,
                easing: 'easeInOutSine',
                duration: 350
            })
            this.$emit('end')
        }
    }
}
</script>

<style scoped lang='less'>
.voice-wrapper {
    pointer-events: none;
    opacity: 0;
    width: 5.1rem;
    height: 5.1rem;
    border-radius: 0.25rem;
    font-size: 0.5rem;
    color: #fff;
    position: absolute;
    z-index: 1;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: rgba(0, 0, 0, 0.42);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .text {
        margin-top: 0.5rem;
    }
}
.cls-1 {
    isolation: isolate;
}

.cls-2 {
    fill: #fff;
}

.cls-3,
.cls-5 {
    fill: none;
}

.cls-3 {
    stroke: #fff;
    stroke-width: 1.5px;
}

.cls-4 {
    stroke: none;
}
</style>